/*
 * @Author: LGY 18588437913@163.com
 * @Date: 2023-02-20 11:41:37
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-20 11:47:57
 * @FilePath: /dz-signup-stupc/src/api/form.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { axios } from "@/utils/request";

// 获取表单类型
export function getInfoType(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/infoType",
    method: "get",
    params: params,
  });
}

// 学生填报状态 sid
export function getStatus(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/stuStatu",
    method: "get",
    params: params,
  });
}

// 表单下载
export function download(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/infoDown",
    method: "get",
    params: params,
  });
}

/**
 * 报名确认
 */
//信息核对

//信息查询
export function getStuInfo(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/stuInfo",
    method: "get",
    params,
  });
}
// 获取学生详情
export function getStuDetail(params = {}) {
  return axios({
    url: "/welcome/publish/school/student/getStuDetail",
    method: "get",
    params,
  });
}

// 获取学生下的专业项目
export function getZyprojectListPage(params = {}) {
  return axios({
    url: "/welcome/publish/recruit/recruitMajorProject/list/page",
    method: "GET",
    params: params,
  });
}
export function queryMajorProject(params = {}) {
  return axios({
    url: "/welcome/publish/recruit/recruitMajorProject/queryMajorProject",
    method: "get",
    params,
  });
}
//获取采集项配置
export function getTypeCong(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/infoTypeConfig",
    method: "get",
    params,
  });
}
//获取科目、成绩输入配置
export function getSubjectConfig(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/sign/getCollectScoreConf",
    method: "get",
    params,
  });
}
//信息提交
export function saveStuInfo(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/saveInfo",
    method: "post",
    data: params,
  });
}

//信息提交
export function updateInfoType(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/saveStatus",
    method: "post",
    data: params,
  });
}

// 查询学生状态
export function getStuStatus(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/recruitStatus",
    method: "get",
    params: params,
  });
}

export function getDicAll(params = {}) {
  return axios({
    url: "/welcome/publish/admin/dict/type/listin",
    method: "get",
    params,
  });
}
// 获取行政区划数据
export function getCity(params = {}) {
  return axios({
    url: "/welcome/publish/admin/region/list/all",
    method: "get",
    params,
  });
}

//获取合作企业
export function getCooperaEnterList(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/get/cooperaEnterList",
    method: "get",
    params,
  });
}
//获取合作企业 -志愿二
export function getCooperaEnter2List(params = {}) {
  return axios({
    url: "/welcome/publish/cooperaEnter/queryCooperaEnterIdByZyId",
    method: "get",
    params,
  });
}

// 获取报到意向
export function getArrivalIntent(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/arrivalIntent/get",
    method: "get",
    params,
  });
}

// 保存报到意向
export function saveArrivalIntent(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/recruit/arrivalIntent/save",
    method: "post",
    data: params,
  });
}

